import * as Yup from "yup";
import React, { useState } from "react";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { Box, Button } from "@mui/material";
import Form1 from "./Form1";
import Form2 from "./Form2";
import Form3 from "./Form3";
import MetaPixel from "../../components/MetaPixel";
import { Modal } from "react-bootstrap";
import logo from "../../assets/image/logo.png";
import ReactLoading from "react-loading";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import validationSchema from "./ValidationSchema";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { jobConfiguration } from "../../service/jobconfigApi";
import { currentUser } from "../../helpers";
import {
  GetCustomSettingTemplate,
  UpdateMultiStepper,
} from "../../service/authApi";

const steps = ["Step 1", "Step 2", "Step 3"];

const trimA = (value) => {
  if (typeof value === "string") {
    return value.trim();
  }
  return value;
};
const userInfo = currentUser();

export default function MultistepperForm() {
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    mode: "onChange",
  });
  const [activeStep, setActiveStep] = useState(0);
  const [loader, setLoader] = useState(false);
  const [formVisible, setFormVisible] = useState(false);
  const [modalContent, setModalContent] = useState({
    thankYouJobCreation: "",
    thankyouForJobNote: "",
  });
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
  };
  const userInfo = currentUser();
  const handleNext = async () => {
    const isLastStep = activeStep === steps.length - 1;

    let result;
    switch (activeStep) {
      case 0:
        if (methods.getValues("overheadCostsToggle") === "no")
          methods.setValue(
            "overheadCosts",
            Number(methods.getValues("amount")) * 0.36
          );

        methods.setValue("jobConfigName", "Company Overhead");
        methods.setValue("jobConfigDescription", " ");

        result = await methods.trigger([
          "amount",
          "variableCost",
          "overheadCostsToggle",
          "overheadCosts",
        ]);

        break;

      case 1:
        result = await methods.trigger(["ownersPay", "loans", "other"]);
        break;

      case 2:
        const employeesAnswer = methods.getValues("employees");
        let fieldsToTrigger = ["employees"];

        if (employeesAnswer === "no") {
          fieldsToTrigger.push("highPaidsecd");
          methods.getValues("highPaidsecd");
          methods.setValue("midPaid", 35);
          methods.setValue("lowPaid", 20);
          methods.setValue("employeesCount", 0);
          methods.setValue("monthlyMidPaid", 0);
          methods.setValue("monthlyLowPaid", 0);
        } else {
          fieldsToTrigger.push(
            "highPaid",
            "monthlyHighPaid",
            "midPaid",
            "monthlyMidPaid",
            "lowPaid",
            "monthlyLowPaid"
          );
        }

        const totalAmount =
          (Number(methods.getValues("amount")) *
            Number(parseFloat(methods.getValues("variableCost")))) /
            100 +
          Number(methods.getValues("overheadCosts")) +
          Number(methods.getValues("ownersPay")) +
          Number(methods.getValues("loans")) +
          Number(methods.getValues("other"));
        methods.setValue("totalAmount", Number(totalAmount));

        result = await methods.trigger(fieldsToTrigger);

        try {
          const response = await UpdateMultiStepper(
            userInfo?.userId,
            "multiStepper"
          );
        } catch (error) {
          console.log(error);
        }

        break;
      default:
        break;
    }

    if (!result) {
      console.log("Validation failed", methods.formState.errors);
      return;
    }
    const userRole = userInfo?.userRole;
    const ParentID = userInfo?.createdBy;
    const adminId = userInfo?.userId;
    if (isLastStep) {
      const values = methods.getValues();
      const payload = {
        jobConfigName: values.jobConfigName || "Company Overhead",
        jobConfigDescription: values.jobConfigDescription || " ",
        monthlyVariableCost: parseFloat(values.variableCost) || 0,

        amount: Number(values.amount) || 0,
        overheadCostMonthlyHours: values.overheadCosts || 0,
        ownersPayMonthlyHours:
          values.ownersPay && values.ownersPay.length
            ? Number(values.ownersPay) || 0
            : 0,
        loansMonthlyHours:
          values.loans && values.loans.length ? Number(values.loans) || 0 : 0,
        others:
          values.other && values.other.length ? Number(values.other) || 0 : 0,
        companyAdminId:
          userRole === "CompanyAdmin"
            ? adminId
            : userRole === "CompanyManager"
            ? ParentID
            : "",
        totalAmount: values.totalAmount || 0,
        laborCostHigh: {
          dollarPerhour:
            Number(
              (values?.highPaid && values?.highPaid) ||
                (values?.highPaidsecd && values?.highPaidsecd)
            ) || 0,
          laborBurden: 30,
        },
        laborCostMid: {
          dollarPerhour: Number(values.midPaid) || 0,
          laborBurden: 30,
        },
        laborCostLow: {
          dollarPerhour: Number(values.lowPaid) || 0,
          laborBurden: 30,
        },
        breakEvenHigh: {
          averageMonthlyHours: 174,
          numberOfPeople: Number(values.monthlyHighPaid) || 1,
        },
        breakEvenMid: {
          averageMonthlyHours: 174,
          numberOfPeople: Number(values.monthlyMidPaid) || 0,
        },
        breakEvenLow: {
          averageMonthlyHours: 174,
          numberOfPeople: Number(values.monthlyLowPaid) || 0,
        },
      };
      setLoader(true);
      try {
        const response = await jobConfiguration(payload);
        if (response)
          toast.success("Job configuration is successfully created!");
        await fetchData();
        setFormVisible(true);
      } catch (error) {
        toast.error("Failed to create job configuration.");
      } finally {
        setLoader(false);
      }
    } else {
      setActiveStep((prev) => prev + 1);
    }
  };

  const handleClose = () => {
    setFormVisible(false);
    navigate("/signup-flow/add-user");
  };

  const renderForm = () => {
    switch (activeStep) {
      case 0:
        return <Form1 />;
      case 1:
        return <Form2 />;
      case 2:
        return <Form3 />;
      default:
        return null;
    }
  };
  const fetchData = async () => {
    try {
      setLoader(true);
      const data = await GetCustomSettingTemplate();

      if (data.status) {
        // Assuming the API returns an object with body content
        setModalContent({
          thankYouJobCreation:
            data.data.thankYouJobCreation ||
            "Default body content if API fails to provide.",
          thankyouForJobNote: data.data.thankyouForJobNote,
        });
      } else {
        setError(data.data.message || "Failed to fetch data");
      }
    } catch (err) {
      setError(err.message || "An error occurred while fetching data");
    } finally {
      setLoader(false);
    }
  };
  return (
    <FormProvider {...methods}>
      <>
        <MetaPixel />
        <div className="container-fluid bg-white custom-parent">
          <div
            style={{ minHeight: "100vh" }}
            className="row custom-row bg-white"
          >
            <div className="col-lg-12">
              <div className="formcollectionContainer">
                <div className="logo formlogo">
                  <img src={logo} alt="" className="s" />
                </div>
                <div className="form_text">
                  <div className="container d-flex flex-column ">
                    <div className="JobformHead">
                      <div className="heading d-flex align-item-center">
                        <h1 className="main-heading jobCreate">Job Creation</h1>
                      </div>
                      <p className="sub-heading mb-4">
                        Please create a new Job.
                      </p>
                    </div>
                    <div className="stepperform mb-5">
                      <Stepper
                        className="custom-stepper bg-white p-3 rounded-4 shadow-sm"
                        activeStep={activeStep}
                        alternativeLabel
                      >
                        {steps.map((label) => (
                          <Step key={label} className="custom-step">
                            <StepLabel className="custom-step-label">
                              {label}
                            </StepLabel>
                          </Step>
                        ))}
                      </Stepper>
                      <div className="formCollection">{renderForm()}</div>
                      <Box
                        className="rounded-4 p-3 custom-box"
                        sx={{ display: "flex", flexDirection: "row", pt: 2 }}
                      >
                        {activeStep !== 0 && (
                          <Button
                            className="custom-button-back"
                            color="inherit"
                            variant="contained"
                            onClick={handleBack}
                            sx={{ mr: 1 }}
                          >
                            Back
                          </Button>
                        )}
                        <Box sx={{ flex: "1 1 auto" }} />
                        <Button
                          className="custom-button-next"
                          variant="contained"
                          onClick={handleNext}
                        >
                          {activeStep === steps.length - 1 ? "Finish" : "Next"}
                        </Button>
                      </Box>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {loader && (
            <ReactLoading
              type={"bars"}
              color="#33995e"
              height={60}
              width={60}
              className={"globe_loader"}
            />
          )}
        </div>
        <Modal show={formVisible} className="custom-modal modal-xl">
          <Modal.Header>
            <div className="modal-title-container">
              <Modal.Title className="thankyou">
                Thank You For Submitting!
              </Modal.Title>
            </div>
          </Modal.Header>
          <div className="modal-body-container jobModal">
            <Modal.Body>
              {loader ? (
                <div>Loading content...</div>
              ) : error ? (
                <div className="text-danger">{error}</div>
              ) : (
                <div>
                  {(
                    <div
                      dangerouslySetInnerHTML={{
                        __html: modalContent.thankYouJobCreation,
                      }}
                    ></div>
                  ) || (
                    <>
                      Thank you for submitting your overhead. The job
                      configuration tab has been set up successfully. Please
                      ensure you review and edit the numbers to make them as
                      accurate as possible for your company. If your bookkeeping
                      isn't up to date, we've used industry standard numbers
                      based on your answers, so feel free to adjust them to
                      better reflect your actual expenses.
                      <br />
                      <br /> We have just one more question to complete the
                      setup. This step will establish your mobile app login and
                      allow you to access the price book on your computer as
                      well (please note you need to use a different email than
                      your current one). You can add more users and edit their
                      permissions later in the user management section.
                      <br />
                      <br /> After completing this process, please visit the
                      learning center to watch the short videos that will guide
                      you on how to use our platform effectively. These
                      resources will help you maximize the benefits of the
                      program. If you have any questions along the way, don’t
                      hesitate to ask!
                    </>
                  )}
                </div>
              )}
            </Modal.Body>
          </div>
          <Modal.Footer>
            <div
              style={{
                flexGrow: 1,
                alignSelf: "center",
                color: "red",
                fontSize: "16px",
              }}
            >
              {(
                <div
                  dangerouslySetInnerHTML={{
                    __html: modalContent.thankyouForJobNote,
                  }}
                ></div>
              ) || (
                <>
                  <b>Note:</b> Please take a moment to carefully review the
                  above details
                </>
              )}
            </div>
            <Button
              variant=" "
              className="AddUser multiStepperButton  Btn"
              onClick={handleClose}
            >
              Add User
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    </FormProvider>
  );
}
